import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { 
  Restaurant as RestaurantIcon,
  MenuBook as DishIcon,
  Assignment as PlanIcon,
  Kitchen as CookedIcon,
  Grass as IngredientIcon
} from '@mui/icons-material';

const StatsCards = ({ data }) => {
  const { t } = useTranslation();
  
  const stats = [
    {
      title: t('analytics.totalDishes'),
      value: data.totalDishes,
      icon: <DishIcon sx={{ fontSize: 40, color: 'primary.main' }} />,
      color: 'primary.main'
    },
    {
      title: t('analytics.totalPlans'),
      value: data.totalPlans,
      icon: <PlanIcon sx={{ fontSize: 40, color: 'secondary.main' }} />,
      color: 'secondary.main'
    },
    {
      title: t('analytics.cookedDishes'),
      value: data.cookedDishes,
      icon: <CookedIcon sx={{ fontSize: 40, color: 'success.main' }} />,
      color: 'success.main'
    },
    {
      title: t('analytics.totalRestaurants'),
      value: data.totalRestaurants,
      icon: <RestaurantIcon sx={{ fontSize: 40, color: 'warning.main' }} />,
      color: 'warning.main'
    },
    {
      title: t('analytics.totalIngredients'),
      value: data.totalIngredients,
      icon: <IngredientIcon sx={{ fontSize: 40, color: 'info.main' }} />,
      color: 'info.main'
    }
  ];

  return (
    <Grid container spacing={2}>
      {stats.map((stat, index) => (
        <Grid item xs={12} sm={6} md={2.4} key={index}>
          <Card 
            sx={{ 
              height: '100%',
              transition: '0.3s',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: 3
              }
            }}
          >
            <CardContent>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box>
                  <Typography variant="h4" component="div" sx={{ color: stat.color, fontWeight: 'bold' }}>
                    {stat.value}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {stat.title}
                  </Typography>
                </Box>
                <Box>
                  {stat.icon}
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default StatsCards;